<template>
  <div>
    <v-dialog
      v-if="!model"
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text class="pa-4">
          <p class="body-2">Please stand by</p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-else>
      <div class="text-center">
        <div>Please stand by</div>
        <v-progress-circular
          :size="70"
          :width="7"
          color="pink lighten-3"
          indeterminate
        ></v-progress-circular>

        <!-- <v-progress-circular indeterminate class="mb-0"></v-progress-circular> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Boolean,
      default: false,
    },
  },
  name: "loading-dialog",
  data() {
    return {
      dialog: true,
    };
  },
};
</script>
